import { Modal } from '@zorro/design-system/v2/Modal';
import { Box, Text } from '@zorro/web/design-system';

import { ModalFooter } from '../ModalComponents';

type Props = {
  setIsOpen: (value: boolean) => void;
  isOpen: boolean;
  onSubmit: () => void;
  isLoading?: boolean;
};

export const EmployerRemoveEmployeeModal = ({
  setIsOpen,
  isOpen,
  onSubmit,
  isLoading,
}: Props) => {
  const handleCloseModal = () => setIsOpen(false);

  return (
    <Modal
      size="494px"
      isOpen={isOpen}
      onClose={handleCloseModal}
      title="Remove employees first"
    >
      <Box mb="md">
        <Text display="block">
          To delete this company, please first remove all employees:
        </Text>
        <Text display="block">1. Navigate to the Employees page</Text>
        <Text display="block">2. Delete all employees</Text>
        <Text display="block">3. Retry the Delete Company action</Text>
      </Box>
      <ModalFooter
        pt="xl"
        onClose={handleCloseModal}
        onSubmit={onSubmit}
        submitText="Go to employees"
        isLoading={isLoading}
      />
    </Modal>
  );
};
